module.exports = __webpack_public_path__ + "img/4m.6c6b99bd.jpg";